export enum ConversationActionType {
  UntrackedShipment = 'untracked_shipping_instructions',
  CustomShipment = 'custom_shipping_instructions',
  ConfirmPackageSize = 'confirm_package_size',
  ReuploadItem = 'reupload',
  ResolveComplaint = 'resolve_complaint',
  ViewComplaint = 'view_complaint',
  ViewIssueDetails = 'view_issue_details',
  DownloadShippingLabel = 'download_shipping_label',
  CancellationConfirm = 'cancellation_confirm',
  CancellationDecline = 'cancellation_decline',
  TrackShipment = 'track_shipment',
  MarkAsDelivered = 'mark_as_delivered',
  MarkAsShipped = 'mark_as_shipped',
  GetShippingLabel = 'get_shipping_label',
  GoToWallet = 'goto_wallet',
  CompleteTransaction = 'all_is_good',
  CompleteDeliveredTransaction = 'all_is_good_delivered',
  ReportProblem = 'i_have_issues',
  LeaveFeedback = 'leave_feedback',
  UpdateBundle = 'update_bundle',
  WeHaveMet = 'we_have_met',
  ClaimCompensation = 'claim_compensation',
  RequestReturn = 'request_to_return',
  GetReturnShippingLabel = 'get_return_shipping_label',
  ConfirmComplaintResolved = 'confirm_complaint_resolved',
  RefuseComplaintResolved = 'refuse_complaint_resolved',
  ViewDeliveryInstructions = 'view_delivery_instructions',
  OpenQrCode = 'open_qr_code',
  RefundProgress = 'refund_progress',
  NeedHelpSelectChatbotIssue = 'need_help_select_chatbot_issue',
  SelectChatbotIssue = 'select_chatbot_issue',
  ConfirmComplaintResolvedAndLeaveFeedback = 'confirm_complaint_resolved_and_leave_feedback',
  LeaveFeedbackForAgentSupport = 'leave_feedback_for_agent_support',
  SupportRequestResolvedChatbot = 'support_request_resolved_chatbot',
  SupportRequestResolvedAutoReply = 'support_request_resolved_auto_reply',
  SupportRequestNotResolvedChatbot = 'support_request_not_resolved_chatbot',
  SupportRequestNotResolvedAutoReply = 'support_request_not_resolved_auto_reply',
  ContactVintedSupport = 'contact_vinted_support',
  ActivateBalance = 'activate_balance',
  ReturnOrder = 'return_order',
  MarkAsReturnedToSender = 'complete_return_to_sender',
  AppealTheDecision = 'appeal_the_decision',
  UploadItem = 'upload_item',
  ExtendShippingDeadline = 'extend_shipping_deadline',
  CancelShippingDeadlineExtension = 'cancel_shipping_deadline_extension',
  AgreeExtendShippingDeadline = 'agree_extend_shipping_deadline',
  DeclineShippingDeadlineExtension = 'decline_shipping_deadline_extension',
  PromotedClosetPrecheckout = 'promoted_closet_precheckout',
  PromotedClosetStats = 'promoted_closet_stats',
  CancelChangeDeliveryOptionRequest = 'cancel_change_delivery_option_request',
  AcceptChangeHomeDeliveryOptionRequest = 'accept_change_home_delivery_option_request',
  AcceptChangePickupDeliveryOptionRequest = 'accept_change_pickup_delivery_option_request',
  CancelRefundOffer = 'cancel_refund_offer',
  AcceptRefundOffer = 'accept_refund_offer',
  RejectRefundOffer = 'reject_refund_offer',
  ChooseResolution = 'choose_resolution',
}
